export async function fetchAllSheetData(periodEndISO) {
  const url = periodEndISO
    ? `/.netlify/functions/sheets?periodEnd=${encodeURIComponent(periodEndISO)}`
    : '/.netlify/functions/sheets';
  const res = await fetch(url);
  if (!res.ok) {
    // 403 = this session isn't in APP_USERS (every ordinary driver/guest portal
    // login hits this — the bulk /sheets endpoint is admin-only). Tag the status
    // so callers can stay silent for drivers instead of alarming them, while a
    // genuine outage (network / 5xx) still surfaces.
    const err = new Error(`Sheets function failed: ${res.status}`);
    err.status = res.status;
    throw err;
  }
  const data = await res.json();
  if (!data.success) throw new Error(data.error || 'Unknown error');
  return data;
}
